import Layout from 'antd/es/layout';
const { Header } = Layout;

export default Header;
